var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable max-statements */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useLoaderData } from 'react-router-dom';

import { Translate } from "../../../../I18N";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { Card } from "../../../Components/UI";
import { getStats } from "../../../api/settings";
import { formatBytes } from "../../../shared/formatHelpers";








const dashboardLoader =
(headers) =>
async () =>
getStats(headers);

const Dashboard = () => {
  const stats = useLoaderData();
  const storage = formatBytes(stats.storage.total);
  const [storageValue, storageUnits] = storage.split(' ');

  return /*#__PURE__*/(
    _jsx("div", { className: "tw-content", style: { width: '100%', overflowY: 'auto' } }, void 0, /*#__PURE__*/
    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Dashboard" }), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "grid grid-cols-1 gap-4 md:grid-cols-2" }, void 0, /*#__PURE__*/
    _jsx(Card, { title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Users") }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col gap-2" }, void 0, /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx("span", { className: "text-5xl font-black text-gray-900" }, void 0, stats.users.total), ' ', /*#__PURE__*/
    _jsx(Translate, { className: "text-lg font-medium text-gray-500" }, void 0, "total users")
    ), /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx("span", { className: "text-gray-700" }, void 0, stats.users.admin), ' ', /*#__PURE__*/
    _jsx(Translate, { className: "mr-4 text-gray-500" }, void 0, "Admins"), /*#__PURE__*/
    _jsx("span", { className: "mr-4 text-gray-200" }, void 0, "|"), /*#__PURE__*/
    _jsx("span", { className: "text-gray-700" }, void 0, stats.users.editor), ' ', /*#__PURE__*/
    _jsx(Translate, { className: "mr-4 text-gray-500" }, void 0, "Editors"), /*#__PURE__*/
    _jsx("span", { className: "mr-4 text-gray-200" }, void 0, "|"), /*#__PURE__*/
    _jsx("span", { className: "text-gray-700" }, void 0, stats.users.collaborator), ' ', /*#__PURE__*/
    _jsx(Translate, { className: "text-gray-500" }, void 0, "Collaborators")
    )
    )
    ), /*#__PURE__*/
    _jsx(Card, { title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Storage") }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col gap-2" }, void 0, /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx("span", { className: "text-5xl font-black text-gray-900" }, void 0, storageValue), ' ', /*#__PURE__*/
    _jsx(Translate, { className: "text-lg font-medium text-gray-500" }, void 0,
    storageUnits
    )
    ), /*#__PURE__*/
    _jsx(Translate, { className: "text-gray-500" }, void 0, "Files and database usage")
    )
    ), /*#__PURE__*/
    _jsx(Card, { title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Entities") }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col gap-2" }, void 0, /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx("span", { className: "text-5xl font-black text-gray-900" }, void 0, stats.entities.total), ' ', /*#__PURE__*/
    _jsx(Translate, { className: "text-lg font-medium text-gray-500" }, void 0, "total entities"

    )
    ), /*#__PURE__*/
    _jsx(Translate, { className: "text-gray-500" }, void 0, "Entities across all languages")
    )
    ), /*#__PURE__*/
    _jsx(Card, { title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Files") }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col gap-2" }, void 0, /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx("span", { className: "text-5xl font-black text-gray-900" }, void 0, stats.files.total), ' ', /*#__PURE__*/
    _jsx(Translate, { className: "text-lg font-medium text-gray-500" }, void 0, "total files")
    ), /*#__PURE__*/
    _jsx(Translate, { className: "text-gray-500" }, void 0, "Total files from main documents, supporting files and uploads"

    )
    )
    )
    )
    ), /*#__PURE__*/
    _jsx(SettingsContent.Footer, {})
    )
    ));

};

export { Dashboard, dashboardLoader };